import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LandingPageBanner } from 'src/app/models/firebase/landingPageBanner';
import { AuthService } from 'src/app/service/auth/auth.service';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

    @Input() servicesData:LandingPageBanner = null;
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    constructor(
        private authService: AuthService,
        private router: Router
    ){}

    ngOnInit() {
    }

    goToService(link:string, id:string){
        this.router.navigate([`/enterprise-services/${link}/${id}`])
    }

}
